import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MainComponent } from './main.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { AppView } from './models/app.view';
import { MaintenanceComponent } from './maintenance/maintenance.component';

@NgModule({
  imports: [RouterModule.forRoot([
    {
      path: '',
      component: MainComponent,
      data: {
        viewMode: AppView.App
      }
    },
    {
      path: 'widget',
      component: MainComponent,
      data: {
        viewMode: AppView.Widget
      }
    },
    {
      path: 'error',
      component: ErrorPageComponent
    },
    {
      path: 'maintenance',
      component: MaintenanceComponent
    },
    {
      path: '**',
      redirectTo: ''
    }])],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
